
import { BaseAPI } from "../../BaseAPI";
import { CtvBasvuruRequest } from './CtvBasvuruave';
import * as environment from '../../../config/environment';

class KatBasvuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "KatBasvuruSave";
    super(baseUrl);
  }


  saveKatBasvuruSave(request: any){
    
    return this.post("", request, true);
   
  }

}
export default new KatBasvuruAPI();
//CTV MODELİNİ KULLANIYOR